import { memo } from 'react';
import { Box, Text } from '@bonanza-social/moonlight';
import { AcceptableDocumentsTableRowProps } from './AcceptableDocumentsTableRow.types';

function AcceptableDocumentsTableRow({
  titleKey,
  descriptionKey,
  titleVariant = 'body-s-semi',
  descriptionVariant = 'body-s-semi',
  ...rest
}: AcceptableDocumentsTableRowProps) {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      paddingVertical="space-200"
      marginHorizontal="space-200"
      {...rest}
    >
      <Text
        variant={titleVariant}
        locKey={titleKey}
        locNS="onboarding"
        color="darkSurfacePrimary"
        flex={1}
      />
      <Text
        variant={descriptionVariant}
        locKey={descriptionKey}
        locNS="onboarding"
        color="darkSurfacePrimary"
        flex={2}
      />
    </Box>
  );
}

export default memo(AcceptableDocumentsTableRow);
